<template>
  <div class="layout">
    <div id="loading" v-if="loading">
      <div class="load-box">
        <img src="@/assets/img/loading-14.gif" class="load" />
        <p>Loading...</p>
      </div>
    </div>

    <div id="loading" v-if="!loading && !HallList.length">
      <div class="load-box">
        <p>No data！</p>
      </div>
    </div>

    <div v-wechat-title="$route.meta.title=docTitle"></div>
    <searchBar @search="openSearch=true" :theme="1"></searchBar>

    <van-tabs v-model="activeName" @click="changeTab" class="head_nav" v-if="HallList.length">
      <van-tab :title="item.name" :name="item.name" v-for="(item,index) in HallList" :key="index"></van-tab>
    </van-tabs>

    <!-- 公司信息 -->
    <comMsg :Bind="Bind" :comData="comData" @changeBind="changeBind" @openBind="Bind = true"></comMsg>

    <!-- 展位图 -->
    <div id="Map" ref="main" :style="background">
    </div>

    <div class="map-tool" @click="showFullMap = true" v-if="boothFullMap">
      <img src="@/assets/img/icon/icon-map.png">
    </div>

    <!-- 全景图 -->
    <div class="boothFullMap">
      <van-popup v-model="showFullMap" overlay-class="my-overlay">
        <div class="FullMap">
          <p>
            <!-- <img :src="boothFullMap"> -->
            <img :src="boothFullMap" preview="0">
          </p>
          <i class="icon iconfont icon-guanbi" @click="showFullMap = false"></i>
        </div>
      </van-popup>
    </div>

    <layoutFooter></layoutFooter>
    <!-- 热门搜索 -->
    <searchPage :show="openSearch" :placeholder="placeholder" :type="rankingType" @callback="setSearch" ref="search"></searchPage>
    <!-- 侧边栏 -->
    <exTool :isZT="false" :isZX="false"></exTool>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import layoutFooter from "@components/layout-footer";
import searchBar from "@components/searchBar/index";
import searchPage from "@/components/searchPage"; // 搜索页
import exTool from "../home/components/ex-tool";
import comMsg from './component/zs-bot.vue';
import gql from 'graphql-tag';
import G6 from '@antv/g6';
export default {
  name: "activity",
  data () {
    return {
      openSearch: false,
      docTitle: "Floorplan",
      rankingType: "CompInfo", // 默认显示展商
      searchType: 0, // 搜索类型
      placeholder: '公司名称/展馆/类别',
      shareV: {
        content: '',
        poster: '',
      },
      loading: true, // 加载显示
      HallList: [],
      g2d: null,
      selectHallList: null,
      initColor: "#addfff",
      hoverColor: "#3498db",
      selectColor: "#fe781d",
      background: "background:#f2faff", // 默认展位图背景色
      Bind: false,  // 绑定公司
      isSearchOpen: false, // 搜索弹框；
      selectNode: null, // 选中的节点
      comData: null, // 选中的公司信息
      exConfig: null,
      hallId: null,
      boothFullMap: '',
      showFullMap: false, // 全景图
      activeName: '',
    };
  },
  components: {
    layoutFooter,
    searchBar,
    searchPage,
    exTool,
    comMsg,
  },
  computed: {
    ...mapGetters({
      exhibitionId: 'getExhibitionId',
      exhibitionInfo: 'getExhibitionInfo',
      userId: "getUserId",
      hallListData: 'hall/getHallListData', // 展位图数据
      selectBoothComId: 'hall/getSelectBoothComId',
    }),
    cWidth () { return document.body.clientWidth; },
    cHeight () { return document.body.clientHeight - 100; },
    hallGql () {
      return gql`query {
                map {
                  maps(exhibitionId: "${this.exhibitionId}", isShow: true) {
                    backImage
                    name
                    nameEn
                    shortName
                    id
                    width
                    height
                    isShow
                    shapes {
                      shapeIndex
                      angle
                      shapeType
                      borderColor
                      fillColor
                      text
                      nodes
                      boothCode
                      openingDirection
                      boothArea
                      height
                      width
                      length
                      id
                      businessData {
                        dealId
                        rowState
                        exhibitor {
                          joinId
                          name
                          nameEn
                          shortName
                        }
                      }
                    }
                  }
                }
              }`
    },
  },
  created () {
    this.init();
  },
  mounted () {
    this.$Bus.$off('searchShow')
    this.$Bus.$on('searchShow', () => {
      this.changeBind(false);
    })
    this.$preview.on("imageLoadComplete", (e, item) => { });
  },
  methods: {
    changeTab (type, name) {
      this.HallList.forEach(c => {
        if (c.name === name) {
          this.$Myapollo.addExhibitionView();
          this.selcetHallMap(c);
        }
      });
    },
    ...mapActions({
      LinkAct: 'linkTo/LinkAct',
      shareToWechat: 'wxShare/shareToWechat',
      getSettingShare: 'wxShare/getSettingShare', //分享配置展会
    }),
    async init () {
      let exhibitionId = this.$route.params.id;
      this.$store.commit("setExhibitionId", exhibitionId);
      await this.$Myapollo.getExhibitionInfo(this, exhibitionId, this.userId);
      this.boothFullMap = this.exhibitionInfo.exhibition.hallPanorama;
      if (this.exhibitionInfo && this.exhibitionInfo.exhibition) {
        this.docTitle = this.exhibitionInfo.exhibition.nameEn || this.exhibitionInfo.exhibition.name + '-Floorplan';
      }
      // 展位图数据
      this.hallId = this.$route.query.exhibitorId ? this.$route.query.exhibitorId : null;
      console.log(this.hallId, 'this.hallId------------');
      // if(this.hallListData){
      //     this.HallList = this.hallListData;
      //     this.selectHallList = this.hallListData[0];
      //     this.loading = false;
      // }else{
      this.loading = await this.initHallData();
      // }
      this.searchHall()
      if (!this.loading && this.selectHallList) {
        this.creatCanvas();
      }

      // 分享的配置
      await this.getShareVal();
      const opt = {
        title: this.shareV.content ? this.shareV.content : '诚邀您参观 ' + this.exhibitionInfo.exhibition.name + ' 线上展',
        desc: this.shareV.des || this.exhibitionInfo.exhibition.remark,
        link: window.location.href,
        imgUrl: this.exhibitionInfo.exhibition.logo
      };
      this.shareToWechat(opt);
    },

    // 初始化展馆数据；
    initHallData () {
      console.log('initHallData', this.exhibitionId);
      return new Promise((resolve, reject) => {
        this.$apollo
          .query({
            query: this.hallGql,
            variables: {
              exhibitionId: this.exhibitionId,
              isShow: true,
            },
            client: 'api'      //如果请求不同的路径用client标识选的路径
          })
          .then(res => {
            this.HallList = res.data.map.maps;
            // this.$store.commit('hall/setHallListData',this.HallList);
            this.selectHallList = this.HallList[0];
            this.activeName = this.selectHallList.name;
            console.log(this.HallList, '展位图数据');
            console.log('initHallData', this.HallList);
            resolve(false);
          })
          .catch(error => {
            console.log(error, '展位图数据error');
            resolve(false);
          })

      });
    },

    // 根据搜索公司的id绘制出展馆
    searchHall () {
      this.HallList.map(v => {
        v.shapes.map(c => {
          if (c.businessData && c.businessData.length) {
            c.businessData.map(j => {
              console.log(j)
              if (j.exhibitor && j.exhibitor.joinId === this.hallId) {
                this.selectHallList = v;
                this.activeName = this.selectHallList.name;
              }
            })
          }
        })
      })
    },
    // 搜索展位
    sreachHallAddr () {
      var value = this.hallId;
      console.log(value, "搜索的条件");
      if (value) {
        var has = false;
        this.g2d.find("node", node => {
          if (
            node.get("model").hasOwnProperty("HallMsg") &&
            node.get("model").HallMsg
          ) {
            let comList = node.get("model").HallMsg.hasOwnProperty("businessData") ? node.get("model").HallMsg.businessData : []; // 防止一个展位对应多个公司
            comList.map(c => {
              if (c.exhibitor && c.exhibitor.joinId === value) {  // 可能一家公司有多个展位
                if (node !== this.selectNode) {
                  if (this.selectNode) {
                    // console.log('删除前一个')
                    this.g2d.setItemState(this.selectNode, "selected", false);
                  }
                  if (node) {
                    // console.log('绘制现在')
                    this.g2d.setItemState(node, "selected", true);
                    this.SelNode(node, this.g2d);
                    //  this.handleNodeClick(node,this.g2d);
                  }
                  this.selectNode = node;
                }
                has = true;
              }
            });
            if (node.get("model").HallMsg.boothCode === value) { // 没有绑定公司的展位  (按展位搜索)
              if (node !== this.selectNode) {
                if (this.selectNode) {
                  this.g2d.setItemState(this.selectNode, "selected", false);
                }
                if (node) {
                  this.g2d.setItemState(node, "selected", true);
                  this.SelNode(node, this.g2d);
                }
                this.selectNode = node;
              }
              has = true;
            }
          }
        });
      }
      if (!has) {
        // 没有选中
        // this.$Message.warning(`未匹配到此展位号，请联系主办方客服`);
        console.log(`未匹配到此展位号，请联系主办方客服`)
      }
    },

    creatCanvas () {  // 单个展馆
      // 创建 G6 图实例
      let HallMsg = this.selectHallList;
      let AllW = HallMsg.width;
      let MaxH = HallMsg.height;
      console.log(this.cWidth, "画布宽度");
      console.log(this.cHeight, "画布高度");
      console.log(MaxH, "最大高度");
      console.log(AllW, "总宽度");
      // var Wscale = this.cWidth / AllW < 4 ? this.cWidth / AllW : 4; // 宽度比
      var Wscale = 3.798;
      console.log(Wscale, "宽度比例");
      var Hscale = (this.cHeight - MaxH * Wscale) / 2;
      var Wcenter = (this.cWidth - AllW * Wscale) / 2;
      console.log(Wcenter, "宽度居中比例");
      // var Hscale = 1;
      console.log(Hscale, "高度比例");

      // 循环绘制展位
      HallMsg.shapes.map((v, i) => {
        if (JSON.parse(v.nodes).length < 4) {
          return true;
        } else {
          var points = [];
          let Nodes = JSON.parse(v.nodes);
          Nodes.map(v => {
            points.push(
              [(v.X) * Wscale + Wcenter, v.Y * Wscale + Hscale] //x轴减去的值和展馆底图位置图一致；
            );
          });
          let minWidth = Nodes[2].X - Nodes[0].X > 0 ? Nodes[0].X : Nodes[2].X; // 最小的坐标
          var bWidth = (Nodes[2].X - Nodes[0].X) * Wscale; //展位宽度
          bWidth = Math.abs(bWidth);
          var bHeight = (Nodes[2].Y - Nodes[0].Y) * Wscale; //展位宽度

          // 字体
          var hWidth = v.width;
          var fSize = 0;
          let hS = 0;
          let ws = Wscale;

          if (hWidth < 3.3) {
            // 一个标展的宽度
            if (v.boothCode && v.boothCode.length > 4) {
              ws = Wscale - (v.boothCode.length - 4) * 0.1;
            }
            hS = 1;
          }
          if (hWidth >= 3.3) {
            // 2个标展的宽度
            if (v.boothCode && v.boothCode.length > 4) {
              ws = Wscale - (v.boothCode.length - 4) * 0.1;
            }
            hS = 1.2 + (hWidth / 3) * 0.1;
          }
          fSize = v.boothCode ? ((3 * ws) / 2) * hS : 4;


          // console.log(v.BoothCode, v,hWidth,fSize,'字体');

          // (字体的计算，字体大小6像素；文字截取以标展3*3为单位，以一个展位号为4位数为基本，算出截取时一个文字的大小)
          // var fSize =  3* Wscale / 4 ;
          // var text = this.fittingString(v.BoothCode, hWidth, fSize); // 展位字体 (文字内容，最大宽度，字体大小)
          if (v.shapeType == 'TEXT_SHAPE') { // 文本
            if (v.text) {
              v.text = v.text.indexOf('[') !== -1 ? JSON.parse(v.text) : v.text
            } else {
              v.text = null;
            }
            if (v.text) {
              G6.registerNode(
                v.id,
                {
                  drawShape: function drawShape (cfg, group) {
                    const img = group.addShape("text", {
                      attrs: {
                        x: (minWidth) * Wscale + Wcenter + bWidth / 2, // 居中
                        y: Nodes[0].Y * Wscale + Hscale + bHeight / 2,
                        textAlign: "center",
                        textBaseline: "center",
                        text: v.text[0].text,
                        fill: "#333",
                        fontSize: v.text[0].fontSize / 3,
                        fontFamily: "微软雅黑",
                      }
                    });
                    return img;
                  }
                },
                "single-shape"
              );
            }
          } else {
            G6.registerNode(v.boothCode + i, {
              // 绘制自定义节点
              drawShape: (cfg, group) => {
                const rect = group.addShape("polygon", {
                  attrs: {
                    points: points,
                    fill: this.initColor, // 初始展位颜色
                    lineWidth: 0.5,
                    stroke: "#000", // 边框色（滑过色）
                    cursor: "pointer"
                  }
                });
                group.addShape("text", {
                  // attrs: style
                  attrs: {
                    x: (minWidth) * Wscale + Wcenter + bWidth / 2, // 居中
                    y: Nodes[0].Y * Wscale + Hscale + bHeight / 2,
                    textAlign: "center",
                    textBaseline: "middle",
                    text: v.boothCode,
                    fill: "#333",
                    fontSize: fSize,
                    cursor: "pointer",
                    fontFamily: "微软雅黑",
                    W: bWidth,
                  }
                });
                return rect;
              },
              // 响应状态变化
              setState: (name, value, item) => {
                const group = item.getContainer();
                const shape = group.get("children")[0]; // 顺序根据 draw 时确定 绘制的多边形
                const text = group.get("children")[1]; // 顺序根据 draw 时确定 绘制的多边形
                if (name === "selected") { // 选中的节点
                  if (value) {
                    shape.attr("fill", this.selectColor);
                    text.attr("fill", "#fff");
                  } else {
                    shape.attr("fill", this.initColor);
                    text.attr("fill", "#333");
                  }
                }
                if (name === "active") { // 切换颜色
                  const style = {
                    fill: this.initColor
                  };
                  if (value) {
                    shape.attr(style);
                  } else {
                    shape.attr(style);
                  }
                }
              }
            }, "single-shape"); //single-shape 是这些内置节点图形的基类，也可以基于它进行扩展。
          }
        }
      });

      let node = [];
      let Hall = [];
      // 循环绘制展馆
      G6.registerNode(HallMsg.name, {
        drawShape: function drawShape (cfg, group) {
          const img = group.addShape("image", {
            attrs: {
              x: (0) * Wscale + Wcenter,
              y: 0 + Hscale,
              width: HallMsg.width * Wscale,
              height: HallMsg.height * Wscale,
              img: HallMsg.backImage
              // cursor: 'pointer'
            }
          });
          group.addShape("text", {
            attrs: {
              x: (0) * Wscale + Wcenter + (HallMsg.width / 2) * Wscale, // 居中
              y: 0 + Hscale - 10,
              textAlign: "center",
              textBaseline: "bottom",
              text: HallMsg.name,
              fill: "#333",
              fontSize: 30,
              fontWeight: 600
            }
          });
          return img;
        }
      }, "single-shape");
      Hall.push({ x: 0, y: 0, shape: HallMsg.name });

      HallMsg.shapes.map((v, i) => {
        if (JSON.parse(v.nodes).length < 4) {
          return true;
        } else {
          var hallMsg = null;
          let Nodes = JSON.parse(v.nodes);
          if (v.shapeType == 'TEXT_SHAPE') {  // 判断是否为文本
            if (v.text) {
              hallMsg = {
                x: 0,
                y: 0,
                shape: v.id,
                // bWidth:bWidth,
                // HallMsg: v,
                w: (Nodes[0].X) * Wscale + Wcenter, // 当前节点的左上角坐标x轴
                h: Nodes[0].Y * Wscale + Hscale,  // 当前节点的左上角坐标Y轴
                ComId: v.businessData && v.businessData.length && v.businessData[0].exhibitor ? v.businessData[0].exhibitor.joinId : ""
              };
            }
          } else {
            hallMsg = {
              x: 0,
              y: 0,
              shape: v.boothCode + i,
              // bWidth:bWidth,
              HallMsg: v,
              w: (Nodes[0].X) * Wscale + Wcenter, // 当前节点的左上角坐标x轴
              h: Nodes[0].Y * Wscale + Hscale,  // 当前节点的左上角坐标Y轴
              ComId: v.businessData && v.businessData.length && v.businessData[0].exhibitor ? v.businessData[0].exhibitor.joinId : ""
            };
          }
          if (hallMsg) {
            node.push(hallMsg);
          }
        }
      });

      const data = {
        nodes: [...Hall, ...node]
      };

      // 实例化 Grid 插件

      this.g2d = new G6.Graph({
        container: "Map", // 指定图画布的容器 id
        // 画布宽高
        width: this.cWidth,
        height: this.cHeight,
        fitView: true,
        modes: {
          default: ["drag-canvas", "zoom-canvas"]
        }
      });
      const graph = this.g2d;


      // 读取数据
      graph.data(data);
      // 渲染图
      graph.render();

      // 渲染完毕执行搜索
      this.sreachHallAddr();

      // 缩放拖拽画布
      var start = [];
      var istouch = false;
      var myMap = document.getElementById('Map');
      myMap.addEventListener('touchstart', e => {
        start = [];
        istouch = false;
        // console.log(e,'touchstart');
        if (e.touches.length >= 2) { //判断是否有两个点在屏幕上
          istouch = true;
          start = e.touches; //得到第一组两个点
          console.log(start, 'start')
        }
      });

      // 拖拽画布
      var x = 0;
      var y = 0;
      myMap.addEventListener('touchmove', e => {
        e.preventDefault();
        // console.log(e,'touchmove')
        if (e.touches.length == 1) { // 单指移动
          if (x != 0 && y != 0) {
            var xx = x - e.touches[0].pageX;
            var yy = y - e.touches[0].pageY;
            graph.translate(-xx, -yy);
          }
          x = e.touches[0].pageX;
          y = e.touches[0].pageY;
        }
        if (e.touches.length >= 2 && istouch) { // 双指缩放
          var now = e.touches; //得到第二组两个点
          var scale = this.getDistance(now[0], now[1]) / this.getDistance(start[0], start[1]); //得到缩放比例，getDistance是勾股定理的一个方法
          scale = scale.toFixed(2);
          if (scale > 1) { // 放大
            graph.zoom(1.05, { x: this.cWidth / 2, y: this.cHeight / 2 });
          }
          if (scale < 1) { // 缩小
            graph.zoom(0.95, { x: this.cWidth / 2, y: this.cHeight / 2 });
          }
        }
      }, false);

      myMap.addEventListener('touchend', e => {
        // e.preventDefault() ;
        // console.log(e,'touchend')
        x = 0;
        y = 0;
      }, false);


      // 切换选中改变样式
      graph.on('node:click', ev => {
        const node = ev.item;
        // console.log(node,'选中的节点');
        if (this.selectNode != node && node._cfg.model.HallMsg) {
          if (this.selectNode) {
            graph.setItemState(this.selectNode, 'selected', false); // 初始化选中
          }
          if (node._cfg.model.HallMsg) { // 展位节点；
            // this.selectHall = node._cfg.model.HallMsg; // 点击选中的公司
            this.selectNode = node;
            graph.setItemState(node, 'selected', true); // 切换选中
            this.SelNode(node, graph);
          }
        }
      });
    },

    getDistance (p1, p2) {
      var x = p2.pageX - p1.pageX,
        y = p2.pageY - p1.pageY;
      return Math.sqrt((x * x) + (y * y));
    },

    // 选择展馆（切换展馆）
    selcetHallMap (hallType) {
      console.log(hallType);
      this.changeBind(false); // 取消公司弹框并取消选中状态
      this.g2d.destroy(); // 销毁画布
      this.selectHallList = hallType;
      this.creatCanvas(); // 重新绘制
    },

    // 选中节点的操作
    SelNode (Node, graph) { // 选中节点后的操作
      console.log(Node, '选中的节点操作');
      graph.zoomTo(2, { x: Node._cfg.model.w, y: Node._cfg.model.h });
      this.handleNodeClick(Node, graph);
      this.clickComp(Node); // 绘制选中的公司
    },

    // 选中平移(搜索选中)
    handleNodeClick (node, graph) {
      const item = node;
      // 聚焦当前点击的节点（把节点放到视口中心）
      const matrix = item._cfg.model;

      const point = {
        // 当前节点的坐标
        x: matrix.w,
        y: matrix.h
      };
      const width = graph.get("width");
      const height = graph.get("height");
      // 找到视口中心
      const viewCenter = {
        x: width / 2,
        y: height / 2 - 150, // 减去公司弹框的初始一高度
      };
      const modelCenter = graph.getPointByCanvas(viewCenter.x, viewCenter.y);
      const viewportMatrix = graph.get("group").getMatrix();
      // 画布平移的目标位置，最终目标是graph.translate(dx, dy);
      // console.log(viewportMatrix, "viewportMatrix");
      const dx = (modelCenter.x - point.x) * viewportMatrix[0];
      const dy = (modelCenter.y - point.y) * viewportMatrix[4];
      let lastX = 0;
      let lastY = 0;
      let newX = void 0;
      let newY = void 0;
      // console.log(dx, dy, "dx", newX, newY);
      // 动画每次平移一点，直到目标位置
      graph.get("canvas").animate(
        {
          onFrame: function onFrame (ratio) {
            newX = dx * ratio;
            newY = dy * ratio;
            graph.translate(newX - lastX, newY - lastY);
            lastX = newX;
            lastY = newY;
          }
        },
        300,
        "easeCubic"
      );
    },
    // 显示选中公司弹框
    clickComp (Com) {
      //鼠标点击绘制公司
      var comp = Com._cfg.model.HallMsg; // 当前的公司；
      // 显示公司；
      this.comData = comp;
      console.log(comp, "点击选中展位");
      this.Bind = true;
    },

    // 关闭公司弹框；并删除展位选中状态
    changeBind (msg) {
      this.Bind = msg;
      if (this.selectNode) {
        this.delSelcetHall();
      }
    },

    // 删除选中展位的选中样式
    delSelcetHall () {
      console.log(this.selectNode, "删除当前选中展位的样式");
      this.g2d.setItemState(this.selectNode, "selected", false); // 删除选中的样式
      this.selectNode = null;
    },


    // 获取展会的分享配置
    async getShareVal () {
      let res = await this.getSettingShare({ id: this.exhibitionId, name: 'share.exhibition.config' });
      if (res) {
        this.shareV = JSON.parse(res);
      }
      this.isShareV = true;
    },
    setSearch (e) {
      // 设置搜索值
      console.log(e, '设置搜索值')
      this.openSearch = false;
      this.searchText = e.txt;
      this.searchType = e.type;  // 0为输入搜索，1为展馆，2为类别
      this.$store.commit('setSearch', this.searchText)
      if (this.searchText) {
        this.$router.push(`/exhibition/${this.exhibitionId}?search=${this.searchText}&searchType=${this.searchType}`)
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.layout {
  // min-height: 100vh;
  // padding-bottom: 55px;
  padding-top: 0.93rem;
  // background-color: #f2f2f2;
}
.act-info {
  .list {
    flex-direction: column;
    padding: 10px 15px;
    background: #fff;
    border-bottom: 10px solid #f2f2f2;
    &-title {
      font-weight: 600;
      font-size: 16px;
      display: flex;
      align-items: center;
      line-height: 1.5;
      // margin-bottom: 12px;
      .my-brand {
        // margin-right: 4px;
        // background-image: linear-gradient(90deg, #56ccf2 0%, #2f80ed 100%),
        //   linear-gradient(#000, #000);
        //   text-align: center;
        line-height: initial;
        width: 0.88rem;
        height: 0.3rem;
        display: flex;
        justify-content: center;
        align-items: center;
        background-blend-mode: normal, normal;
        border-radius: 0.05rem;
        color: #fff;
        font-size: 0.18rem;
        vertical-align: middle;
        margin-right: 4px;
      }
      .dot {
        background-image: linear-gradient(90deg, #ff416c 0%, #ff4b2b 100%),
          linear-gradient(#000, #000);
      }
      .s-gray {
        background-image: linear-gradient(90deg, #ffc659 0%, #ffa751 100%),
          linear-gradient(#bfbfbf, #bfbfbf);
      }
      &-txt {
        display: inline-block;
        max-width: 150px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        // margin-right: 10px;
        font-size: 15px;
        color: #333;
      }
      &-txt2 {
        flex: 1;
        font-size: 12px;
        color: #666;
        text-align: right;
      }
    }
    &-main {
      display: flex;
      align-items: center;
      font-size: 12px;
      margin-top: 8px;
      color: rgb(102, 102, 102);
      position: relative;
      left: -3px;
      .brand {
        line-height: 1.2;
        margin-right: 8px;
        font-size: 0.22rem;
        &.z-right {
          justify-self: flex-end;
          flex: 1;
          span {
            display: inline-block;
            width: 100%;
            text-align: right;
          }
        }
        span {
          color: #999;
          line-height: 18px;
          display: inline-block;
          display: flex;
          align-items: center;
          font-size: 0.24rem;
          .icon-dianzan,
          .icon-guanzhu {
            font-size: 0.36rem;
          }
          .icon-zhiboguankanshu {
            position: relative;
            top: 1px;
          }
          .icon-guanzhu {
            position: relative;
            top: -1px;
          }
        }
        .iconfont {
          font-size: 0.36rem;
          display: inline-block;
        }
      }
      &.z-padd {
        margin: 2px 0 0 0;
      }
      .ranking-conten-guanKan {
        display: inline-block;
        width: 16px;
        height: 14px;
        position: relative;
        top: 3px;
        margin-right: 2px;
      }
      .rc-border {
        border: 1px solid rgb(230, 230, 230);
        border-radius: 2px;
        margin-right: 5px;
        padding: 1px 2px;
        display: inline-block;
        max-width: 100%;
        overflow: hidden;
        line-height: 1.2;
        .icon {
          font-size: 12px;
          position: relative;
          left: 1px;
        }
        span {
          position: relative;
          left: -2px;
        }
        &.z-padd {
          padding: 1px 3px 1px 0;
        }
      }
    }
  }
}
#loading .load-box {
  position: absolute;
  width: 200px;
  height: 100px;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  margin: auto;
}
.load-box .load {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
  display: block;
}
.load-box p {
  font-size: 14px;
  color: #333;
  margin: 0;
  position: absolute;
  top: 75px;
  margin: auto;
  width: 100%;
  text-align: center;
}
.boothFullMap {
  .FullMap {
    width: 6rem;
    height: 200px;
    background: #fff;
    position: relative;
    padding: 15px;
    p {
      width: 100%;
      margin: auto;
      height: 100%;
      position: relative;
      img {
        display: block;
        position: absolute;
        left: 0;
        top: 0;
        bottom: 0;
        right: 0;
        margin: auto;
        max-width: 90%;
        max-height: 90%;
      }
    }
    i {
      position: absolute;
      right: 0;
      top: 10px;
      width: 10%;
      color: #ccc;
      text-align: center;
      font-size: 20px;
    }
  }
}
.map-tool {
  position: fixed;
  z-index: 15;
  bottom: 1.18rem;
  right: 0.25rem;
  display: flex;
  flex-direction: row-reverse;
  flex-wrap: wrap;
  width: 1.1rem;
  justify-content: center;
  img {
    width: 1.1rem;
    height: 1.1rem;
  }
}
</style>